import React, { useReducer } from "react";
import axiosClient from "../../config/axios";

import jwtDecode from "jwt-decode";
import AuthContext from "./authContext";
import AuthReducer from "./authReducer";

import tokenAuth from "../../config/token";

import {
  AUTHENTICATED_USER,
  SUCCESS_LOGIN,
  ERROR_LOGIN,
  CLOSE_SESION,
  CHANGE_PASSWORD_OK,
  TELL_A_FRIEND_OK,
  REGENERATE_UNAUTHORIZED_DOCUMENTS,
  GET_PENDING_DOCUMENTS,
  ASK_FOR_ANEW_SERVICE_OK,
  RECEIVE_NEW_VOUCHER_TO_PROCESS_OK,
  SUCCESS_FORGOT_PASSWORD,
  ERROR_FORGOT_PASSWORD,
  SET_AUTH,
  GET_THE_NEWS_RESPONSE,
  ERROR_GET_DATA
} from "../../types";


const AuthState = (props) => {
  const initialState = {
    token: localStorage.getItem("token"),
    authenticated: !localStorage.getItem("authenticated")
      ? null
      : localStorage.getItem("authenticated"),
    user: null,
    message: null,
    loading: true,
    hasToChange: !localStorage.getItem("hasToChange")
      ? false
      : localStorage.getItem("hasToChange"),
    forgotPasswordOk: null,
    showLoginExpiredMessage: false,
    data: null
  };

  const [state, dispatch] = useReducer(AuthReducer, initialState);

  const authenticatedUser = async () => {
    const token = localStorage.getItem("token")
      ? localStorage.getItem("token")
      : null;

    if (!token) {
      dispatch({
        type: ERROR_LOGIN,
      });
    } else {
      const decodedToken = jwtDecode(token);

      const currentTime = new Date().getTime() / 1000;
      if (currentTime > decodedToken.exp && !token) {
        dispatch({
          type: ERROR_LOGIN,
        });
      } else {
        tokenAuth(token);
        dispatch({
          type: AUTHENTICATED_USER,
        });
      }
    }
  };

  const logIn = async (data) => {
    try {
      const response = await axiosClient.post("/token", data);

      if (response.data.data.responseCode === 0) {
        dispatch({
          type: SUCCESS_LOGIN,
          payload: response.data.data,
        });
      }
      //console.table( response.data )
      if (response.data.data.responseCode === -1) {
        const errorMessage = response.data.data.responseMessage;
        let error = {
          message: "",
        };
        error.message = errorMessage;
        throw error;
      }
      return true;
    } catch (error) {
      const alert = {
        msg: !error ? "ha ocurrido un error" : error.message,
        category: "error",
      };
      dispatch({
        type: ERROR_LOGIN,
        payload: alert,
      });

      return false;
    }
  };

  const forgotPassword = async (data) => {
    try {
      const response = await axiosClient.post("forgotpassword", data);

      dispatch({
        type: SUCCESS_FORGOT_PASSWORD,
      });

      return response.data.data;
    } catch (error) {
      dispatch({
        type: ERROR_FORGOT_PASSWORD,
      });
      return false;
    }
  };

  const changePassword = async (data) => {
    try {
      const response = await axiosClient.post("/changePassword", data);
      dispatch({
        type: CHANGE_PASSWORD_OK,
      });
      return response.data.data;
    } catch (error) {
      ///FIXME: sessionExpired
      return false;
    }
  };

  const changePasswordPos = async (data) => {
    try {
      const response = await axiosClient.post("/changePasswordPos", data);
      dispatch({
        type: CHANGE_PASSWORD_OK,
      });
      return response.data.data;
    } catch (error) {
      ///FIXME: sessionExpired
      return false;
    }
  };

  const tellAFriend = async (data) => {
    try {
      const response = await axiosClient.post("/tellAFriend", data);
      dispatch({
        type: TELL_A_FRIEND_OK,
      });
      return response.data.data;
    } catch (error) {
      return false;
    }
  };

  const regenerateUnauthorizedDocuments = async (data) => {
    try {
      const response = await axiosClient.post("/regenerateUnauthorizedDocuments", data);
      dispatch({
        type: REGENERATE_UNAUTHORIZED_DOCUMENTS,
      });
      return response.data.data;
    } catch (error) {
      ///FIXME: sessionExpired
      return false;
    }
  };

  const getQuantityPendingDocuments = async (data) => {
    try {
      const response = await axiosClient.post("/getQuantityPendingDocuments", data);
      dispatch({
        type: GET_PENDING_DOCUMENTS
      });
      return response.data.data;
    } catch (error) {
      ///FIXME: sessionExpired
      return false;
    }
  };

  const askForANewService = async (data) => {
    try {
      const response = await axiosClient.post("/askForANewService", data);
      dispatch({
        type: ASK_FOR_ANEW_SERVICE_OK,
      });
      return response.data.data;
    } catch (error) {
      ///FIXME: sessionExpired
      return false;
    }
  };

  const receiveNewVoucherToProcess = async (data) => {
    try {
      const response = await axiosClient.post("/receiveNewVoucherToProcess", data);
      dispatch({
        type: RECEIVE_NEW_VOUCHER_TO_PROCESS_OK,
      });
      return response.data.data;
    } catch (error) {
      ///FIXME: sessionExpired
      return false;
    }
  };
  const getTheNews = async () => {
    try {
      const response = await axiosClient.get("/news" )
      dispatch({
        type: GET_THE_NEWS_RESPONSE,
        payload: response
      });
    } catch (error) {
     if (error.response.status === 401) {
        dispatch({
          type: CLOSE_SESION,
          payload: "La sesiòn ha caducado, por favor haga login nuevamente", //error.message,
        });
      }
      else {
        dispatch({
          type: ERROR_GET_DATA,
          payload: "Ha ocurrido un error al cargar los datos.", //error.message,
        });
      }
    }
  };
 
  const closeSession = () => {
    dispatch({
      type: CLOSE_SESION,
    });
  };

  const setAuthenticated = () => {
    dispatch({
      type: SET_AUTH,
    });
  };

  return (
    <AuthContext.Provider
      value={{
        token: state.token,
        authenticated: state.authenticated,
        user: state.user,
        message: state.message,
        loading: state.loading,
        hasToChange: state.hasToChange,
        showLoginExpiredMessage: state.showLoginExpiredMessage,
        news:state.news,
        logIn,
        authenticatedUser,
        forgotPassword,
        changePassword,
        askForANewService,
        receiveNewVoucherToProcess,
        changePasswordPos,
        tellAFriend,
        regenerateUnauthorizedDocuments,
        getQuantityPendingDocuments,
        closeSession,
        setAuthenticated,
        getTheNews, //TODO move to home context
      }}
    >
      {props.children}
    </AuthContext.Provider>
  );
};

export default AuthState;
